__turbopack_context__.v({
  "allNewsBtn": "b9v5qG_allNewsBtn",
  "contentStyles": "b9v5qG_contentStyles",
  "newsBottomController": "b9v5qG_newsBottomController",
  "rowsContainer": "b9v5qG_rowsContainer",
  "showAllNewsBtn": "b9v5qG_showAllNewsBtn",
  "sliderControllerBtn": "b9v5qG_sliderControllerBtn",
  "sliderControllerBtnDiactive": "b9v5qG_sliderControllerBtnDiactive",
  "titleH3Styles": "b9v5qG_titleH3Styles",
});
